<div class="inner-content dark:bg-contrast-black" ridangoAppTrapFocus>
    <div class="flex-column flex h-full text-base dark:bg-contrast-black">
        <div class="relative flex items-center border-b border-solid p-4 dark:border-contrast-yellow">
            <p class="w-full text-center font-semibold">{{ 'CART_SELECT_PURPOSE' | translate }}</p>
            <button
                class="!absolute right-4"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon class="close-button-icon font-bold">close</mat-icon>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto">
            <mat-radio-group class="vertical-radio-group">
                <ng-container *ngIf="purposes?.length">
                    <div
                        class="mx-4 border-b border-solid py-4 dark:border-contrast-yellow"
                        *ngFor="let purpose of purposes"
                        (click)="onPurposeChange(purpose)">
                        <mat-radio-button
                            class="vertical-radio-button"
                            [value]="purpose?.id"
                            [checked]="selectedPurpose?.id === purpose.id">
                            {{
                                purpose?.title === tripPurposes.other
                                    ? ('CART_OTHER_PURPOSE' | translate)
                                    : purpose?.title
                            }}
                        </mat-radio-button>
                    </div>
                </ng-container>
            </mat-radio-group>
        </div>
        <div class="m-4">
            <ion-button
                class="select-button orb-app-light:text-black sr-app-light:text-white h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                [disabled]="!selectedPurpose?.title"
                (click)="handleSaveClick()">
                {{ 'BUTTON_SELECT' | translate }}
            </ion-button>
        </div>
    </div>
</div>
